import "./styles.scss";

const CurrencyText = ({
  className = "",
  value,
  iconPosition = "left",
  skipFormatted = false,
}) => {
  // Handle empty states
  if (value === null || value === undefined || value === "") {
    return <span className={className}>--</span>;
  }

  const rawValue = value.toString();

  let displayValue;

  if (skipFormatted) {
    // Only remove SAR, no formatting
    displayValue = rawValue.replace(/sar/gi, "").trim();
  } else {
    // Remove SAR text
    const cleanedValue = rawValue.replace(/sar/gi, "").trim();

    // Split single or range values (– or -)
    const parts = cleanedValue.split(/\s*[–-]\s*/);

    const formattedParts = parts.map((part) => {
      const numeric = Number(part.replace(/[^\d.]/g, ""));
      if (isNaN(numeric)) return "--";
      return new Intl.NumberFormat("en-SA").format(numeric);
    });

    displayValue = formattedParts.join(" – ");
  }

  return (
    <div className={`currency-text-container ${className}`}>
      {iconPosition === "left" && <span className="icon-saudi_riyal" />}
      <span>{displayValue}</span>
      {iconPosition === "right" && <span className="icon-saudi_riyal" />}
    </div>
  );
};

export default CurrencyText;
